<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Top-up Amount" prop="topUpAmount" >
        <a-input-number
          v-model="form.topUpAmount"
          :min="0"
          :step="0.01"
          :precision="2"
          :formatter="moneyFormatter"
          :parser="moneyParser"
          placeholder="Please enter top-up amount"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Bonus Amount" prop="giveMoney" >
        <a-input-number
          v-model="form.giveMoney"
          :min="0"
          :step="0.01"
          :precision="2"
          :formatter="moneyFormatter"
          :parser="moneyParser"
          placeholder="Please enter bonus amount"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="Name" prop="tagTitle" >
        <a-input v-model="form.tagTitle" placeholder="Please enter tag name" />
      </a-form-model-item>
      <a-form-model-item label="Sort (Ascending)" prop="sort" >
        <a-input-number
          v-model="form.sort"
          :min="0"
          :step="1"
          :precision="0"
          placeholder="Please enter sort order"
          style="width: 100%"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeMenu, addRechargeMenu, updateRechargeMenu } from '@/api/golf/rechargeMenu'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,

        topUpAmount: null,

        giveMoney: null,

        tagTitle: null,

        productId: null,

        sort: null,

        createTime: null,

        remark: null

      },
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        topUpAmount: null,
        giveMoney: null,
        tagTitle: null,
        productId: null,
        sort: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeMenu({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    moneyFormatter (value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }
      return `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    moneyParser (value) {
      if (!value) {
        return ''
      }
      return value.replace(/￥\s?|(,*)/g, '')
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRechargeMenu(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRechargeMenu(this.form).then(response => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
